.datepicker-form-field{width:100%}.datepicker-icon{padding:0 6px 0 0!important}mat-datepicker-toggle{padding-right:6px!important}.datepicker-error{width:180px!important;height:80px;text-wrap:normal}
/*# sourceMappingURL=datepicker.component-FYGS3XA5.css.map */
